import { useState, useMemo } from 'react'

import _ from 'lodash'

import {
  LegacyPage,
  LoadingContainer,
  Panels,
  Bar,
  MiniTable,
  Json,
  Input,
  Link,
  Stack,
} from 'peach/components'
import { humanizeKey, getName } from 'peach/helpers'
import { useParams, useRouteMatch } from 'peach/router'

import {
  useInternalListTemplateDescriptors,
  useInternalListTemplateVersionsModern,
} from 'core/types'

const TemplateSubjects = () => {
  const { url } = useRouteMatch()
  const { companyId } = useParams<{
    companyId?: string
  }>()

  const {
    data: descriptors,
    isLoading: descriptorsLoading,
    error: descriptorsError,
  } = useInternalListTemplateDescriptors({
    companyId,
  })

  const {
    data: templates,
    isLoading: templatesLoading,
    error: templatesError,
  } = useInternalListTemplateVersionsModern({
    companyId,
  })

  const error = descriptorsError || templatesError

  const templatesByDescirptorId = useMemo(
    () => _.groupBy(templates, 'descriptorId'),
    [templates],
  )

  const groups = _.groupBy(descriptors, 'subject')

  const [quickSearch, setQuickSearch] = useState('')

  const search = (
    <Input
      bare
      onChange={setQuickSearch}
      placeholder='Search Subjects'
      value={quickSearch}
      width='320px'
    />
  )

  const subjects = _.map(groups, (descriptors, subject) => {
    const templates = _.flatten(
      _.compact(_.map(descriptors, ({ id }) => templatesByDescirptorId[id])),
    )
    return { subject, descriptors, templates }
  })

  const filteredSubjects = _.filter(subjects, ({ subject = '' }) => {
    const query = quickSearch.trim().toLowerCase()
    return subject.toLowerCase().includes(query)
  })

  const rows = _.map(
    filteredSubjects,
    ({ subject, descriptors, templates }) => {
      const activeTemplateIds = _.compact(_.map(descriptors, 'activeVersionId'))
      const activeTempaltes = _.filter(templates, ({ id }) =>
        _.includes(activeTemplateIds, id),
      )

      return (
        <MiniTable.Row key={subject}>
          <Link to={`${url}/${subject}`}>{humanizeKey(subject)}</Link>
          <Stack>
            {_.map(descriptors, ({ channel }) => (
              <Link key={channel} to={`${url}/${subject}/${channel}`}>
                {humanizeKey(channel)}
              </Link>
            ))}
          </Stack>
          <Json.List compact json={_.map(activeTempaltes, getName)} />
        </MiniTable.Row>
      )
    },
  )

  return (
    <LoadingContainer
      error={error}
      isLoading={descriptorsLoading || templatesLoading}
    >
      <Panels header={<Bar left={search} />}>
        <LegacyPage.Full>
          <MiniTable
            columns={['Subject', 'Channels', 'Active Templates']}
            fixed
          >
            {rows}
          </MiniTable>
        </LegacyPage.Full>
      </Panels>
    </LoadingContainer>
  )
}

export default TemplateSubjects
